import {useContext, useEffect, useState} from 'react'
import { ProviderValue, useAxios } from '../../config/axios-config'
import { PageLoader } from '../util/PageLoader'
import { ErrorPage } from '../error/ErrorPage'
import {Col, Container, InputGroup, Row, Form, Button} from "react-bootstrap";
import './style.css'
import {UserContext} from "../../App";
import {AccountRequestDTO} from "../../model/AccountRequestDTO";
import {AccountResponseDTO} from "../../model/ResponsesDTO";
import {Divider} from "antd";
import {isMobile} from "react-device-detect";

export const AccountPage = () => {

  const axiosInstance = useAxios() as ProviderValue
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  const [companyName, setCompanyName] = useState<string>('')
  const [optionalDescription, setOptionalDescription] = useState<string>('')
  const [tempOptionalDescription, setTempOptionalDescription] = useState<string>('')
  const [errors, setErrors] = useState<Record<string, string[]>>({})
  const [editMode, setEditMode] = useState<boolean>(false)
  const {userCompanyName, setUserCompanyName} = useContext(UserContext)

  const controller = new AbortController();
  const signal = controller.signal

  useEffect(() => {
    axiosInstance.get<AccountResponseDTO>(`/accounts/secure/findaccount`, {signal}).then((response) => {
      setCompanyName(response.data.name)
      setOptionalDescription(response.data.optionalDescription)
      setTempOptionalDescription(response.data.optionalDescription)
      setIsLoaded(true)
      setIsError(false)
    }).catch((e) => {
      console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
      setIsLoaded(true)
      setIsError(true)
    })
    // eslint-disable-next-line
  }, []);

  const handleSave = async (value : any) => {
    value.preventDefault()
    setIsLoaded(false)
    let newValidation = validateFields()
    if (Object.values(newValidation).some((error) => error)) {
      setErrors(newValidation)
      setIsLoaded(true)
      return;
    }
    var requestDTO = new AccountRequestDTO(companyName, optionalDescription, undefined)
    await axiosInstance.patch<AccountResponseDTO>(`/accounts/secure/update`, requestDTO, {signal}).then((response) => {
      setUserCompanyName(response.data.name)
      setCompanyName(response.data.name)
      setOptionalDescription(response.data.optionalDescription)
      setTempOptionalDescription(response.data.optionalDescription)
      setIsLoaded(true)
      setIsError(false)
    }).catch((e) => {
      console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
      setIsLoaded(true)
      setIsError(true)
    })
    setErrors({})
    setIsLoaded(true)
    setIsError(false)
    setEditMode(false)
  }

  const validateFields = () => {
    let tempErrors : Record<string, string[]> = {'companyName' : [], 'optionalDescription' : []
    }
    let errorsPresent = false

    if (companyName === null || companyName === undefined || companyName === '') {
      tempErrors.companyName.push('Pole Nazwy nie może być puste.')
      errorsPresent = true
    } else if (companyName.length > 60) {
      tempErrors.companyName.push('Limit znaków dla Nazwy to 60.')
      errorsPresent = true
    } else if (optionalDescription.length > 250) {
      tempErrors.optionalDescription.push('Limit znaków dla akapitu to 250.')
      errorsPresent = true
    }
    if (!errorsPresent) {
      tempErrors = {}
    }

    return tempErrors
  }

  if (!isLoaded) {
      return (
          <PageLoader />
      )
  }

  if (isError) {
        return (
          <ErrorPage />
        )
  }

  return (
      <Container>
        <Row>
          <Col md={{span: 6, offset: 3}}>
            <Divider variant="dotted" style={{ borderColor: '#1EAE98', color: '#1EAE98' }}>
              Dane konta
            </Divider>
            <Form onSubmit={handleSave}>
              {isMobile ? <InputGroup.Text id="basic-addon1" className={`account-input ${editMode ? `account-edit` : ``}`}>Nazwa placówki</InputGroup.Text>
                  :
                  <></>
              }
            <InputGroup className='mb-3'>
              {isMobile ? <></>
                  :
                  <InputGroup.Text id="basic-addon1" className={`account-input ${editMode ? `account-edit` : ``}`}>Nazwa placówki</InputGroup.Text>
              }
              <Form.Control
                  value={companyName}
                  placeholder='Wpisz nazwę placówki'
                  aria-label="Wpisz nazwę placówki"
                  aria-describedby="basic-addon2"
                  onChange={(e) => setCompanyName(e.target.value)}
                  isInvalid={errors.companyName?.length > 0}
                  onFocus={() => errors.companyName = []}
                  readOnly={!editMode}
              />
              {errors.companyName?.map((error: string, index: number) => (
                  <Form.Control.Feedback key={index} type="invalid">
                    {error}
                  </Form.Control.Feedback>
              ))}
            </InputGroup>
              {isMobile ? <InputGroup.Text id="basic-addon1" className={`account-input ${editMode ? `account-edit` : ``}`}>Ostatni akapit maila</InputGroup.Text>
                  :
                  <></>
              }
            <InputGroup className="mb-3">
              {isMobile ? <></>
                  :
              <InputGroup.Text id="basic-addon1" className={`account-input ${editMode ? `account-edit` : ``}`}>Ostatni akapit maila</InputGroup.Text>
              }
              <Form.Control
                  as={'textarea'}
                  rows={5}
                  value={optionalDescription}
                  placeholder='Wpisz ostatni akapit do maila dla rodziców'
                  aria-label="Wpisz ostatni akapit do maila dla rodziców"
                  aria-describedby="basic-addon2"
                  onChange={(e) => setOptionalDescription(e.target.value)}
                  isInvalid={errors.optionalDescription?.length > 0}
                  onFocus={() => errors.optionalDescription = []}
                  readOnly={!editMode}
              />
              {errors.optionalDescription?.map((error: string, index: number) => (
                  <Form.Control.Feedback key={index} type="invalid">
                    {error}
                  </Form.Control.Feedback>
              ))}
            </InputGroup>
          {editMode ?
              <Row>
                <Col>
                  <Button className='button-65 button-65-width mt-4' type={'submit'}>
                    Zapisz zmiany
                  </Button>
                </Col>
                <Col>
                  <Button className='button-65 button-65-width mt-4' onClick={() => {
                    setErrors({})
                    setCompanyName(userCompanyName);
                    setOptionalDescription(tempOptionalDescription)
                    setEditMode(false)}}>
                    Anuluj
                  </Button>
                </Col>
              </Row>
              :
              <Button className='button-65 button-65-width mt-4' onClick={() => {setEditMode(true)}}>
                Edytuj
              </Button>

          }
            </Form>
          </Col>
        </Row>
      </Container>
  )
}